module.exports = __webpack_public_path__ + "static/img/flowChart2.e327b35a.jpg";